import { useQuery } from '@tanstack/react-query';
import { endpoints, getIDFromUrl, Url, withSideload } from '@rossum/api-client';
import { CustomRelation } from '@rossum/api-client/relations';
import { api } from '../../../lib/apiClient';

const CUSTOM_RELATION_PARENT_NAMES_QUERY_KEY = 'custom-relation-parent-names';

// Resolves original file names of the relations' parent documents. They
// disambiguate same-subtype relations in the drawer relation select.
export const useFetchCustomRelationParentNames = (
  relations: CustomRelation[]
) => {
  const parentIds = relations.flatMap(relation =>
    relation.parent ? [getIDFromUrl(relation.parent)] : []
  );

  const { data } = useQuery({
    queryKey: [CUSTOM_RELATION_PARENT_NAMES_QUERY_KEY, ...parentIds],
    queryFn: () =>
      api.request(
        withSideload(
          endpoints.annotations.list({
            id: parentIds,
            pageSize: parentIds.length,
          }),
          { documents: true }
        )
      ),
    // The names are needed only when there are relations to switch between.
    enabled: relations.length > 1 && parentIds.length > 0,
    keepPreviousData: true,
  });

  const parentNameByUrl: Partial<Record<Url, string>> = Object.fromEntries(
    (data?.results ?? []).flatMap(annotation => {
      const fileName = data?.documents.find(
        document => document.url === annotation.document
      )?.originalFileName;

      return fileName ? [[annotation.url, fileName]] : [];
    })
  );

  return { parentNameByUrl };
};
